import { observer } from 'mobx-react'
import ContentState from '../../../../stores/ContentState'
import Parallax from '../../../common/Parallax'
import { useEffect, useState } from 'react'
import './index.scss'

const WhoWe = observer(() => {
  const content = ContentState
  const [width, setWidth] = useState(window.innerWidth)
  useEffect(() => {
    setWidth(window.innerWidth)
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  if (!content.about) return <></>
  return (
    <section className="who-we">
      <section className="we-block__row">
        <div className="we-block__img">
          <Parallax
            src={
              content.about.whowe.video
                ? content.about.whowe.video!
                : content.about.whowe.img!
            }
            type={content.about.whowe.video ? 'video' : 'img'}
            poster={content.about.whowe.video ? content.about.whowe.poster : ''}
          />
        </div>
        <div className="we-block__col">
          <div
            className="we-block__title"
            dangerouslySetInnerHTML={{
              __html: content.about.whowe.title,
            }}
          ></div>
          <div
            className="we-block__text"
            dangerouslySetInnerHTML={{
              __html: content.about.whowe.text,
            }}
          ></div>
        </div>
      </section>
      <section className="we-block__row next">
        <div className="we-block__col">
          <div
            className="we-block__text"
            dangerouslySetInnerHTML={{
              __html: content.about.whowe.text2,
            }}
          ></div>
        </div>
        <div className="we-block__img">
          <Parallax
            src={
              content.about.whowe.video2
                ? content.about.whowe.video2!
                : content.about.whowe.img2!
            }
            type={content.about.whowe.video2 ? 'video' : 'img'}
            poster={
              content.about.whowe.video2 ? content.about.whowe.poster2 : ''
            }
          />
        </div>
      </section>
    </section>
  )
})

export default WhoWe
